import { jsx as C } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5943 2.6462C11.4161 1.98862 12.5839 1.98862 13.4057 2.6462L20.9057 8.64739C21.4394 9.07438 21.75 9.72077 21.75 10.4042V19.4999C21.75 20.7425 20.7426 21.7499 19.5 21.7499H4.5C3.25736 21.7499 2.25 20.7425 2.25 19.4999V9.68336C2.25 9.45532 2.35372 9.23993 2.53144 9.09773L10.5943 2.6462ZM7.46967 9.46967C7.76256 9.17678 8.23744 9.17678 8.53033 9.46967L12 12.9393L15.4697 9.46967C15.7626 9.17678 16.2374 9.17678 16.5303 9.46967C16.8232 9.76256 16.8232 10.2374 16.5303 10.5303L13.0607 14L16.5303 17.4697C16.8232 17.7626 16.8232 18.2374 16.5303 18.5303C16.2374 18.8232 15.7626 18.8232 15.4697 18.5303L12 15.0607L8.53033 18.5303C8.23744 18.8232 7.76256 18.8232 7.46967 18.5303C7.17678 18.2374 7.17678 17.7626 7.46967 17.4697L10.9393 14L7.46967 10.5303C7.17678 10.2374 7.17678 9.76256 7.46967 9.46967Z",
    fill: "currentColor"
  }
);
export {
  o as default
};
